// Vue
import Vue from "vue";
import App from "./App";
// 多国语
import i18n from "./i18n";

// 菜单和路由设置
import router from "./router";
import menuHeader from "@/menu/header";
import menuAside from "@/menu/aside";
import { frameInRoutes } from "@/router/routes";

// store
import store from "@/store/index";

// 核心插件
import d2Admin from "@/plugin/d2admin";

import { formatDate, numFormat, copyUrl, numFormat2 } from "@/assets/js/mUtils";

import excel from "@d2-projects/vue-table-export";

import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import moment from "moment";

// 设置语言
locale.use(lang);

let echarts = require("echarts");

Vue.prototype.img_host = "https://mwphoto.oss-cn-shenzhen.aliyuncs.com/";
Vue.prototype.formatDate = formatDate;
Vue.prototype.numFormat = numFormat;
Vue.prototype.numFormat2 = numFormat2;
Vue.prototype.copyUrl = copyUrl;
Vue.prototype.echarts = echarts;
Vue.prototype.$moment = moment;
// 核心插件
Vue.use(d2Admin);
Vue.use(excel);
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit("d2admin/page/init", frameInRoutes);
    // 设置顶栏菜单
    this.$store.commit("d2admin/menu/headerSet", menuHeader);
    // 设置侧边栏菜单
    this.$store.commit("d2admin/menu/asideSet", menuAside);
    // 初始化菜单搜索功能
    this.$store.commit("d2admin/search/init", menuHeader);
  },
  mounted() {
    // 展示系统信息
    this.$store.commit("d2admin/releases/versionShow");
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch("d2admin/account/load");
    // 获取并记录用户 UA
    this.$store.commit("d2admin/ua/get");
    // 初始化全屏监听
    this.$store.dispatch("d2admin/fullscreen/listen");
  },
}).$mount("#app");
